function toggleContent(togglebutton) {
    var tuotekorttiElement = togglebutton.closest(".tuotekortti");

    var panel = togglebutton.previousElementSibling;

    var showmore = togglebutton.querySelector(".more");
    var showless = togglebutton.querySelector(".less");


    if (!panel.classList.contains("active")) {

        togglebutton.setAttribute("aria-expanded", "true");
        showmore.classList.remove("show");
        showmore.classList.add("hidden");
        showless.classList.remove("hidden");
        showless.classList.add("show");

        panel.classList.add("active");
        panel.style.height = "auto";

        var height = panel.clientHeight + "px";

        panel.style.height = "0px";

        setTimeout(function () {
            panel.style.height = height;
        }, 0);

    } else {

        togglebutton.setAttribute("aria-expanded", "false");
        showmore.classList.remove("hidden");
        showmore.classList.add("show");
        showless.classList.remove("show");
        showless.classList.add("hidden");

        panel.style.height = "0px";

        panel.addEventListener("transitionend", function () {
            panel.classList.remove("active");
        }, {
        once: true
        });

        scrollToTuotekortti(tuotekorttiElement);

    }
}

function scrollToTuotekortti(tuotekorttiElement) {
    if (tuotekorttiElement) {
        const offset = document.querySelector('.site-header').offsetHeight + 30;

        const elementRect = tuotekorttiElement.getBoundingClientRect();
        const absoluteElementTop = elementRect.top + window.scrollY;
        const scrollToY = absoluteElementTop - offset;

        window.scrollTo({
            top: scrollToY,
            behavior: 'instant'//'smooth'
        });
    }
}

function toggleContentButtons() {
    var togglebutton = document.getElementsByClassName("togglebutton");
    var i;

    if (togglebutton) {
        for (i = 0; i < togglebutton.length; i++) {
            togglebutton[i].addEventListener("click", function() {
                toggleContent(this);
                this.blur();
            });
            togglebutton[i].addEventListener("keyup", function(e) {
                e.preventDefault();
                if ( e.keyCode === 13 || e.keyCode === 32 ) { //enter, space
                    toggleContent(this);
                    this.blur();
                }
            });

        }
    }
};
